import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'LANCAMENTO_VIAGEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setFiltro(filtro) {
    return {
        type: 'LANCAMENTO_VIAGEM_SET_FILTRO',
        payload: filtro
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'LANCAMENTO_VIAGEM_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('lancamentoViagemForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/lancamentoViagem?id_motorista_empresa=${getState().auth.usuario.id_motorista_empresa}`).then(result => {
			dispatch({
				type: 'LANCAMENTO_VIAGEM_LISTADO',
				payload: result
			});
		}).catch(ex => {
			setErroAPI(ex);
		});
	};
}

export function iniciar(registro) {	
    return (dispatch, getState) => {
		dispatch(setAguardando(true));
	    axios.post(`${consts.API_URL}/lancamentoViagem`, {
			...registro,
			id_motorista_empresa: getState().auth.usuario.id_motorista_empresa
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	};
}

export function fechar(registro) {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/lancamentoViagem`, {
			...registro
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	};
}

//ITEM

export function initFormItem(registro = {}) {
    return [
        initialize('lancamentoViagemItemForm', registro)
    ];
}

export function getListaItem() {
	return (dispatch, getState) => {
		let lancamentoViagem = getState().lancamentoViagem.lista[0] || {};

		axios.get(`${consts.API_URL}/lancamentoViagemItem?id_lancamento_viagem=${lancamentoViagem.id || 0}`).then(result => {
			dispatch({
				type: 'LANCAMENTO_VIAGEM_ITEM_LISTADO',
				payload: result
			});
		}).catch(ex => {
			setErroAPI(ex);
		});
	};
}

export function salvarItem(registro) {
    return (dispatch, getState) => {
	
		dispatch(setAguardando(true));
		if (!registro.id) {

			let lancamentoViagem = getState().lancamentoViagem.lista[0] || {};

	        axios.post(`${consts.API_URL}/lancamentoViagemItem`, {
				...registro,
				datahora_lancamento: DateFormat.getDataHoraAtual(),
                id_lancamento_viagem: lancamentoViagem.id,
                id_tipo_lancamento: registro.id_tipo_lancamento,
                quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
                valor: FormatUtils.formatarValorBanco(registro.valor, 2),
                abastecimento_completo: registro.abastecimento_completo || false,
                gera_despesa: true
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaItem());
				dispatch(setModoTela('lista'));
				dispatch(setAguardando(false));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		} else {
			axios.put(`${consts.API_URL}/lancamentoViagemItem`, {
				...registro,
                id_tipo_lancamento: registro.id_tipo_lancamento,
                quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
                valor: FormatUtils.formatarValorBanco(registro.valor, 2),
                abastecimento_completo: registro.abastecimento_completo || false,
                gera_despesa: true
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaItem());
				dispatch(setModoTela('lista'));
				dispatch(setAguardando(false));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		}
    };
}

export function excluirItem(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/lancamentoViagemItem?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaItem());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/lancamentoViagemItem/listarTipoLancamentoSelect`);
    return {
        type: 'LANCAMENTO_VIAGEM_TIPO_LISTADO',
        payload: request
    };
}